<template>
    <!-- <AdminLayout> -->
        <section class="flex items-start">
            <div class="w-full">
                <div class="mt-12" >
                    <div class="border rounded-lg py-7 px-8">
                        <div class="flex justify-between">
                            <p class="font-semibold text-xl text-neutral-800">Attendance Setting</p>
                        </div>
                        <div class=" overflow-x-auto sm:rounded-lg pt-5">
                            <form @submit.prevent="submitAttendanceForm" class="" ref="submitAttendanceForm" name="submitAttendanceForm">
                                <div class="grid grid-cols-2 py-5 gap-7">
                                    <div>
                                        <label class="input-label"> Total Working Hours (Full Day)</label>
                                        <input class="form-control" type="number" placeholder="Add total hours" v-model="attendanceState.defineFullShiftHours" max="20" min="1"/>
                                    </div>
                                    <div>
                                        <label class="input-label ">Total Working Hours (Half Day)</label>
                                        <input class="form-control" type="number" placeholder="Add total hours" v-model="attendanceState.defineHalfShiftHours" max="20" min="1"/>
                                    </div>
                                    <!-- SHIFT TYPE-->
                                    <div class="col-span-2">
                                        <label class="input-label">Choose Shift Type <span class="text-red-500">*</span></label>
                                        <div class="flex">
                                            <div class="radio-box">
                                                <input type="radio" name="shiftTupe" id="general" value="General" v-model="shiftType" />
                                                <label for="general" class="radio-label">General</label>
                                            </div>
                                            <div class="ml-4 radio-box">
                                                <input type="radio" name="shiftTupe" id="Manual" value="Manual" v-model="shiftType" />
                                                <label for="Manual" class="radio-label">Manual</label>
                                            </div>
                                        </div>

                                    </div>
                                    <!-- GENERAL SHIFT -->
                                    <div class="col-span-2" v-if="shiftType == 'General'">
                                        <p class="pt-5 mt-4 text-base font-semibold border-t text-neutral-700 border-neutral-100">Add General Shift</p>
                                        <div class="grid grid-cols-2 py-5 gap-7">
                                            <div>
                                                <label class="text-sm text-neutral-700 font-medium  pb-2 block">General Full Day Shift Hours</label>
                                                <div class="grid grid-cols-2 gap-7">
                                                    <div>
                                                        <label class="input-label">From</label>
                                                        <input class="form-control" type="time" placeholder="Select start hours" v-model="attendanceState.defineFullShiftFrom"/>      
                                                        <p class="text-red-600" v-if="gRosterValidation && attendanceState.defineFullShiftFrom == ''">This field is required</p>                                             
                                                    </div>    
                                                    <div>
                                                        <label class="input-label"> To</label>
                                                        <input class="form-control" type="time" placeholder="Select end hours" v-model="attendanceState.defineFullShiftTo"/>                                  
                                                        <p class="text-red-600" v-if="gRosterValidation && attendanceState.defineFullShiftTo == ''">This field is required</p>                     
                                                    </div>
                                                 
                                                </div>
                                            </div>
                                            <div>
                                                <label class="text-sm text-neutral-700 font-medium pb-2 block">General Half Day Shift Hours</label>
                                                <div class="grid grid-cols-2 gap-7">
                                                    <div>
                                                        <label class="input-label">From</label>
                                                        <input class="form-control" type="time" v-model="attendanceState.defineHalfShiftFrom" placeholder="Select start hours"/>
                                                        <p class="text-red-600" v-if="gRosterValidation && attendanceState.defineHalfShiftFrom == ''">This field is required</p>         
                                                    </div>
                                                    <div>
                                                        <label class="input-label ">To</label>
                                                        <input class="form-control" type="time" v-model="attendanceState.defineHalfShiftTo" placeholder="Select end hours"/>
                                                        <p class="text-red-600" v-if="gRosterValidation && attendanceState.defineHalfShiftTo == ''">This field is required</p>         
                                                    </div>
                                                   
                                                </div>
                                            </div>
                                        </div>

                                        <table class="glob_table">
                                            <thead class="bg-[#ECF6FF]">
                                                <tr>
                                                    <th class="font-medium px-3 py-2.5 w-2/6" >Roster Name</th>
                                                    <th class="font-medium px-3 py-2.5 w-1/6">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(groster, index) in generalRosterList" :key="index">
                                                    <td class="text-sm px-3 py-3">
                                                       {{groster.rosterName}}
                                                    </td>
                                                    <td class="text-sm px-3 py-3">
                                                        <button @click="toggleVisibility(groster.id)" type="button">
                                                            <!-- <svg v-if="isVisible" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" >
                                                                <g fill="none" stroke="#525252" stroke-linecap="round" stroke-width="1.5">
                                                                    <path stroke-linejoin="round" d="M10.73 5.073A11 11 0 0 1 12 5c4.664 0 8.4 2.903 10 7a11.6 11.6 0 0 1-1.555 2.788M6.52 6.519C4.48 7.764 2.9 9.693 2 12c1.6 4.097 5.336 7 10 7a10.44 10.44 0 0 0 5.48-1.52m-7.6-7.6a3 3 0 1 0 4.243 4.243"/>
                                                                    <path d="m4 4l16 16"/>
                                                                </g>
                                                            </svg> -->
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" >
                                                                <g fill="none" stroke="#525252" stroke-width="1.5">
                                                                    <path d="M3.275 15.296C2.425 14.192 2 13.639 2 12c0-1.64.425-2.191 1.275-3.296C4.972 6.5 7.818 4 12 4s7.028 2.5 8.725 4.704C21.575 9.81 22 10.361 22 12c0 1.64-.425 2.191-1.275 3.296C19.028 17.5 16.182 20 12 20s-7.028-2.5-8.725-4.704Z"/>
                                                                    <path d="M15 12a3 3 0 1 1-6 0a3 3 0 0 1 6 0Z"/>
                                                                </g>
                                                            </svg>                                                            
                                                        </button>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>

                                        <div class="col-span-2 mb-4 bg-neutral-100 rounded-md p-4 mt-4" v-if="isVisible">
                                            
                                            <div>
                                                <div class="flex items-center justify-between">
                                                    <label class="input-label">Do working days vary weekly? </label>
                                                    <div class="text-right">
                                                        <button @click="toggleVisibility" type="button" class="inline-flex items-center justify-center bg-red-400/40 rounded-md px-3 py-2 text-red-500 text-xs font-normal">
                                                            Close
                                                        </button>
                                                    </div>
                                                </div>
                                                
                                                <div class="flex pt-2 space-x-3">
                                                    <div class="flex items-center">
                                                        <div class="w-5 h-5 border border-neutral-300 p-1 rounded-full flex items-center justify-center">
                                                            <span class="w-full h-full bg-blue-600 rounded-full"></span>
                                                        </div>
                                                        <p class="text-sm text-black font-normal ml-2">{{this.showGrosterDeatils.workingDaysVaryWeekly}}</p>
                                                    </div>
                                                  
                                                </div>
                                            </div>
                                            <div class="pt-4">
                                                <label class="block pb-2 text-base text-neutral-900">Specify the working days <span class="text-red-500">*</span></label>
                                                <div class="flex items-center py-1 text-xs font-medium rounded bg-[#ECF6FF] text-[#404A5A] w-fit">
                                                    <p class="w-24 pl-3 pt-1 pb-2">Week Name:</p>
                                                    <div class="min-w-[110px] pt-1 pb-2 ml-4">
                                                        <p>Sunday</p>
                                                    </div>
                                                    <div class="min-w-[110px] pt-1 pb-2 ml-4">
                                                        <p>Monday</p>
                                                    </div>
                                                    <div class="min-w-[110px] pt-1 pb-2 ml-4">
                                                        <p>Tuesday</p>
                                                    </div>
                                                    <div class="min-w-[110px] pt-1 pb-2 ml-4">
                                                        <p>Wednesday</p>
                                                    </div>
                                                    <div class="min-w-[110px] pt-1 pb-2 ml-4">
                                                        <p>Thursday</p>
                                                    </div>
                                                    <div class="min-w-[110px] pt-1 pb-2 ml-4">
                                                        <p>Friday</p>
                                                    </div>
                                                    <div class="min-w-[110px] pt-1 pb-2 ml-4">
                                                        <p>Saturday</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div>
                                                <div class="flex items-center py-2" v-for="items in this.showGrosterDeatils.specifyDateGArrays" :key="items.id">
                                                    <p class="w-24 pl-3 text-sm font-semibold text-neutral-700">{{items.weekName}}</p>
                                                    <div class="w-32 ml-4 border border-neutral-200 rounded-md text-sm px-2 py-1" v-for="item in items.days" :key="item.id">
                                                        {{item.val}}
                                                    </div>                                                    
                                                </div>                                             
                                            </div>

                                            <div>
                                                <div class="grid grid-cols-3 py-5 gap-7 border-t mt-5 border-b border-nutral-200" >
                                                    <div>
                                                        <label class="input-label">Roster Name</label>
                                                        <div class="w-full border border-neutral-200 rounded-md text-sm px-4 py-2.5">
                                                            {{this.showGrosterDeatils.rosterName}}
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <label class="input-label">Effective From</label>
                                                        <div class="w-full border border-neutral-200 rounded-md text-sm px-4 py-2.5">
                                                           {{this.showGrosterDeatils.effectiveFrom}}
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <label class="input-label">Effective To</label>
                                                        <div class="w-full border border-neutral-200 rounded-md text-sm px-4 py-2.5">
                                                           {{this.showGrosterDeatils.effectiveTo}}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                          
                                        </div>

                                        <div class="pt-4" v-if="shiftType">
                                            <label class="input-label">Do working days vary weekly? <span class="text-red-500">*</span></label>
                                            <div class="flex pt-2">
                                                <div class="radio-group">
                                                    <input type="radio" name="workingWeek" id="yes" value="yes" v-model="attendanceState.everyWeekGen" />
                                                    <label for="yes" class="radio-label">Yes</label>
                                                </div>
                                                <div class="ml-8 radio-group">
                                                    <input type="radio" name="workingWeek" id="no" value="no" v-model="attendanceState.everyWeekGen" />
                                                    <label for="no" class="radio-label">No</label>
                                                </div>
                                                <p class="text-red-600" v-if="gRosterValidation && attendanceState.everyWeekGen == ''">This field is required</p>   
                                            </div>
                                            <!-- <span v-if="v2$.everyWeekGen.$error1" class="error">
                                                {{ v2$.everyWeekGen.$errors[0].$message }}
                                            </span> -->
                                        </div>
                                        <div class="col-span-2" v-if="attendanceState.everyWeekGen">
                                            <div class="pt-4">
                                                <label class="block pb-2 text-base text-neutral-900">Specify the working days <span class="text-red-500">*</span></label>
                                                <div class="flex items-center py-1 text-xs font-medium rounded bg-[#ECF6FF] text-[#404A5A] w-fit">
                                                    <p class="w-24 pl-3 pt-1 pb-2">Week Name:</p>
                                                    <div class="min-w-[85px] pt-1 pb-2 ml-4">
                                                        <p class="text-center">Sunday</p>
                                                    </div>
                                                    <div class="min-w-[85px] pt-1 pb-2 ml-4">
                                                        <p class="text-center">Monday</p>
                                                    </div>
                                                    <div class="min-w-[85px] pt-1 pb-2 ml-4">
                                                        <p class="text-center">Tuesday</p>
                                                    </div>
                                                    <div class="min-w-[85px] pt-1 pb-2 ml-4">
                                                        <p class="text-center">Wednesday</p>
                                                    </div>
                                                    <div class="min-w-[85px] pt-1 pb-2 ml-4">
                                                        <p class="text-center">Thursday</p>
                                                    </div>
                                                    <div class="min-w-[85px] pt-1 pb-2 ml-4">
                                                        <p class="text-center">Friday</p>
                                                    </div>
                                                    <div class="min-w-[85px] pt-1 pb-2 ml-4">
                                                        <p class="text-center">Saturday</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-if="attendanceState.everyWeekGen === 'yes'" class="divide-y divide-[#eaeaea] w-fit">
                                                <div class="flex items-center py-4" v-for="(items, index) in specifyDateGArrays" :key="index">
                                                    <p class="w-24 pl-3 text-sm font-semibold text-neutral-700">{{items.weekName}} {{ index+1 }}</p>
                                                    <div v-for="item in items.days" :key="item.id" class="w-[85px] ml-4" >
                                                        <select class="shift-control-select" v-model="item.val">
                                                            <option value="full-day">Full Day</option>
                                                            <option value="half-day">Half Day</option>
                                                            <option value="non-working">Non-Working</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-if="attendanceState.everyWeekGen === 'no'">
                                                <div class="flex items-center pt-4 pb-2" v-for="items in specifyDateGOneArray" :key="items.id">
                                                    <p class="w-24 pl-3 text-sm font-semibold text-neutral-700">{{items.weekName}}</p>
                                                    
                                                    <div v-for="item in items.days" :key="item.id" class="w-[85px] ml-4">
                                                        
                                                        <select class="shift-control-select" v-model="item.val">
                                                            <option value="full-day">Full Day</option>
                                                            <option value="half-day">Half Day</option>
                                                            <option value="non-working">Non-Working</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="attendanceState.everyWeekGen">
                                            <div class="grid grid-cols-3 py-5 gap-7 border-t mt-5">
                                                <div>
                                                    <label class="input-label">Roster Name</label>
                                                    <input v-model="attendanceState.rosterName" class="form-control" type="text"  placeholder="Enter Roster Name"/>       
                                                    <p class="text-red-600" v-if="gRosterValidation && attendanceState.rosterName == ''">This field is required</p>                                             
                                                </div>
                                                <div>
                                                    <label class="input-label">Effective From <span class="text-red-500">*</span></label>
                                                    <!-- <datepicker v-model="attendanceState.effectiveGFrom"  :disabled-date="disablePreviousDates"/>  -->
                                                    <!-- <month-picker-input  v-model="attendanceState.effectiveGFrom" :no-default="true"/> -->
                                                    <month-picker-input 
                                                        v-model="attendanceState.effectiveGFrom" 
                                                        :no-default="true" 
                                                        @change="logEffectiveFrom"
                                                    />
                                                    <p class="text-red-600" v-if="gRosterValidation && attendanceState.effectiveGFrom == ''">This field is required</p>        
                                                </div>
                                                <div>
                                                    <label class="input-label">Effective To</label>
                                                    <!-- <month-picker-input v-model="attendanceState.effectiveGTo" :no-default="true"/>  -->
                                                    <month-picker-input 
                                                        v-model="attendanceState.effectiveGTo" 
                                                        :no-default="true" 
                                                        @change="logEffectiveTo"
                                                    />
                                                    <p class="text-red-600" v-if="gRosterValidation && attendanceState.effectiveGTo == ''">This field is required</p> 
                                                </div>
                                            </div>
                                        </div>
                                        
                                    </div>
                                    <!-- MANUAL SHIFT -->
                                    <div class="col-span-2" v-if="shiftType == 'Manual'">
                                        <p v-if="shiftList.length >0" class="pt-5 mt-4 text-base font-semibold border-t text-neutral-700 border-neutral-100">Shift List</p>
                                        <!-- <div> -->
                                        <table class="glob_table" v-if="shiftList.length >0">
                                            <thead class="bg-[#ECF6FF]">
                                                <tr>
                                                    <th class="font-medium px-3 py-2.5 w-2/6" >Shift Name</th>
                                                    <th class="font-medium px-3 py-2.5 w-2/6" >From</th>
                                                    <th class="font-medium px-3 py-2.5 w-2/6" >To</th>
                                                    <th class="font-medium px-3 py-2.5 w-1/6">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr class="border-b text-neutral-700" v-for="shift in shiftList" :key="shift.id">
                                                    <td class="text-sm px-3 py-3">{{ shift.shiftName}} </td>
                                                    <td class="text-sm px-3 py-3">{{ shift.shiftFrom}} </td>
                                                    <td class="text-sm px-3 py-3">{{ shift.shiftTo}} </td>
                                                   
                                                    <td class="text-sm px-3 py-3">
                                                   
                                                        <button @click="deleteShift(shift.shiftName)" class="px-1.5 text-neutral-600 hover:text-red-500 transition-all">
                                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
                                                                <path stroke-linecap="round" stroke-linejoin="round" d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0" />
                                                            </svg>
                                                        </button>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <!-- </div> -->
                                        <p class="pt-5 mt-4 text-base font-semibold border-t text-neutral-700 border-neutral-100">Add Manual Shift</p>
                                        <div class="grid items-end grid-cols-9 gap-3" v-for="(field, index) in addNewShift" :key="index">
                                            
                                            <div class="col-span-4 pt-4">
                                                <label class="input-label">Shift Name <span class="text-red-500">*</span></label>
                                                <input class="form-control" type="text" placeholder="Enter Shift name" v-model="field.shiftName"/>
                                                <p class="text-red-600" v-if="shiftValidation && field.shiftName == ''">This field is required</p>
                                            </div>
                                            <div class="col-span-2 pt-4">
                                                <label class="input-label">From <span class="text-red-500">*</span></label>
                                                <input class="form-control" type="time" placeholder="" v-model="field.from"/>
                                                <p class="text-red-600" v-if="shiftValidation && field.from == ''">This field is required</p>
                                            </div>
                                            <div class="col-span-2 pt-4">
                                                <label class="input-label"> To <span class="text-red-500">*</span></label>
                                                <div class="flex">
                                                    <input class="form-control" type="time" placeholder="" v-model="field.to"/>
                                                    <p class="text-red-600" v-if="shiftValidation && field.to == ''">This field is required</p>
                                                </div>
                                            </div>
                                            <div class="col-span-1">
                                                <button v-if="addNewShift.length > 1" type="button" class="inline-block p-3 text-red-500 border border-red-200 rounded bg-red-50" @click="removeField(index)">
                                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
                                                        <path stroke-linecap="round" stroke-linejoin="round" d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0" />
                                                    </svg>
                                                </button>
                                            </div>
                                        </div>
                                        
                                        <div class="mt-5 py-5 text-sm font-semibold text-blue-500 rounded" >
                                            <!-- @click="closeModal -->
                                            <button 
                                                type="button" 
                                                class="ml-auto mr-2 btn-primary-light"
                                                @click="addShiftDetails()"
                                            >
                                                Save
                                            </button>
                                            <button 
                                                type="button"
                                                class="btn-primary"
                                                @click="addField"
                                            >
                                                Add More
                                            </button>
                                        </div>
                                        <p v-if="rosterList.length >0" class="pt-5 mt-4 text-base font-semibold border-t text-neutral-700 border-neutral-100">Roster List</p>
                                        <!-- <div> -->
                                        <table class="glob_table" v-if="rosterList.length >0">
                                            <thead class="bg-[#ECF6FF]">
                                                <tr>
                                                    <th class="font-medium px-3 py-2.5 w-2/6" >Roster Name</th>
                                                    <th class="font-medium px-3 py-2.5 w-1/6">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr class="border-b text-neutral-700" v-for="roster in rosterList" :key="roster.id">
                                                    <td class="text-sm px-3 py-3" v-if="!roster.editDiv">{{ roster.rosterName}} </td>
                                                    <td class="text-sm px-3 py-3" v-else>
                                                        <input type="text" v-model="roster.rosterName" class="form-control" placeholder="Enter Roster Name"/>
                                                    </td>
                                                    <td class="text-sm px-3 py-3">
                                                        <button @click="toggleVisibilityManual(roster.id)" type="button">                                                         
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" >
                                                                <g fill="none" stroke="#525252" stroke-width="1.5">
                                                                    <path d="M3.275 15.296C2.425 14.192 2 13.639 2 12c0-1.64.425-2.191 1.275-3.296C4.972 6.5 7.818 4 12 4s7.028 2.5 8.725 4.704C21.575 9.81 22 10.361 22 12c0 1.64-.425 2.191-1.275 3.296C19.028 17.5 16.182 20 12 20s-7.028-2.5-8.725-4.704Z"/>
                                                                    <path d="M15 12a3 3 0 1 1-6 0a3 3 0 0 1 6 0Z"/>
                                                                </g>
                                                            </svg>                                                            
                                                        </button>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>

                                        <div class="col-span-2 mb-4 bg-neutral-100 rounded-md p-4 mt-4" v-if="manualisVisible">
                                            
                                            <div>
                                                <div class="flex items-center justify-between">
                                                    <label class="input-label">Do working days vary weekly? </label>
                                                    <div class="text-right">
                                                        <button @click="toggleVisibilityManual" type="button" class="inline-flex items-center justify-center bg-red-400/40 rounded-md px-3 py-2 text-red-500 text-xs font-normal">
                                                            Close
                                                        </button>
                                                    </div>
                                                </div>
                                                
                                                <div class="flex pt-2 space-x-3">
                                                    <div class="flex items-center">
                                                        <div class="w-5 h-5 border border-neutral-300 p-1 rounded-full flex items-center justify-center">
                                                            <span class="w-full h-full bg-blue-600 rounded-full"></span>
                                                        </div>
                                                        <p class="text-sm text-black font-normal ml-2">{{this.showMrosterDeatils.workingDaysVaryWeekly}}</p>
                                                    </div>
                                                  
                                                </div>
                                            </div>
                                            <div class="pt-4">
                                                <label class="block pb-2 text-base text-neutral-900">Specify the working days <span class="text-red-500">*</span></label>
                                                <div class="flex items-center py-1 text-xs font-medium rounded bg-[#ECF6FF] text-[#404A5A]">
                                                    <p class="w-24 pl-3 pt-1 pb-2">Week Name:</p>
                                                    <div class="min-w-[110px] pt-1 pb-2 ml-4">
                                                        <p>Sunday</p>
                                                    </div>
                                                    <div class="min-w-[110px] pt-1 pb-2 ml-4">
                                                        <p>Monday</p>
                                                    </div>
                                                    <div class="min-w-[110px] pt-1 pb-2 ml-4">
                                                        <p>Tuesday</p>
                                                    </div>
                                                    <div class="min-w-[110px] pt-1 pb-2 ml-4">
                                                        <p>Wednesday</p>
                                                    </div>
                                                    <div class="min-w-[110px] pt-1 pb-2 ml-4">
                                                        <p>Thursday</p>
                                                    </div>
                                                    <div class="min-w-[110px] pt-1 pb-2 ml-4">
                                                        <p>Friday</p>
                                                    </div>
                                                    <div class="min-w-[110px] pt-1 pb-2 ml-4">
                                                        <p>Saturday</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div>
                                                <div class="flex items-center py-2" v-for="items in this.showMrosterDeatils.specifyDateMArrays" :key="items.id">
                                                    <p class="w-24 pl-3 text-sm font-semibold text-neutral-700">{{items.weekName}}</p>
                                                    <div class="w-32 ml-4 border border-neutral-200 rounded-md text-sm px-2 py-1" v-for="item in items.days" :key="item.id">
                                                        {{item.val}}
                                                    </div>                                                    
                                                </div>                                             
                                            </div>

                                            <div>
                                                <div class="grid grid-cols-3 py-5 gap-7 border-t mt-5 border-b border-nutral-200" >
                                                    <div>
                                                        <label class="input-label">Roster Name</label>
                                                        <div class="w-full border border-neutral-200 rounded-md text-sm px-4 py-2.5">
                                                            {{this.showMrosterDeatils.rosterName}}
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <label class="input-label">Effective From</label>
                                                        <div class="w-full border border-neutral-200 rounded-md text-sm px-4 py-2.5">
                                                            {{this.showMrosterDeatils.effectiveFrom}}
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <label class="input-label">Effective To</label>
                                                        <div class="w-full border border-neutral-200 rounded-md text-sm px-4 py-2.5">
                                                            {{this.showMrosterDeatils.effectiveTo}}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                          
                                        </div>
                                        <!-- </div> -->
                                        <div class="pt-4 border-t" v-if="shiftType">
                                            <label class="input-label">Do working days vary weekly? <span class="text-red-500">*</span></label>
                                            <div class="flex pt-2">
                                                <div class="radio-group">
                                                    <input type="radio" name="everyWeekMen" id="yes" value="yes" v-model="attendanceState2.everyWeekMen" />
                                                    <label for="yes" class="radio-label">Yes</label>
                                                </div>
                                                <div class="ml-8 radio-group">
                                                    <input type="radio" name="everyWeekMen" id="no" value="no" v-model="attendanceState2.everyWeekMen" />
                                                    <label for="no" class="radio-label">No</label>
                                                </div>
                                            </div>
                                         
                                        </div>
                                        <div class="col-span-2" v-if="attendanceState2.everyWeekMen">
                                            <div class="pt-4">
                                                <label class="block pb-2 text-base text-neutral-900">Specify the working days <span class="text-red-500">*</span></label>
                                                <div class="flex items-center py-1 text-xs font-medium rounded bg-[#ECF6FF] text-[#404A5A] w-fit">
                                                    <p class="w-24 pl-3 pt-1 pb-2">Week Name:</p>
                                                    <div class="min-w-[85px] pt-1 pb-2 ml-4">
                                                        <p class="text-center">Sunday</p>
                                                    </div>
                                                    <div class="min-w-[85px] pt-1 pb-2 ml-4">
                                                        <p class="text-center">Monday</p>
                                                    </div>
                                                    <div class="min-w-[85px] pt-1 pb-2 ml-4">
                                                        <p class="text-center">Tuesday</p>
                                                    </div>
                                                    <div class="min-w-[85px] pt-1 pb-2 ml-4">
                                                        <p class="text-center">Wednesday</p>
                                                    </div>
                                                    <div class="min-w-[85px] pt-1 pb-2 ml-4">
                                                        <p class="text-center">Thursday</p>
                                                    </div>
                                                    <div class="min-w-[85px] pt-1 pb-2 ml-4">
                                                        <p class="text-center">Friday</p>
                                                    </div>
                                                    <div class="min-w-[85px] pt-1 pb-2 ml-4">
                                                        <p class="text-center">Saturday</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-if="attendanceState2.everyWeekMen === 'yes'" class="divide-y divide-[#eaeaea] w-fit">
                                                <div class="flex items-center py-4" v-for="items in specifyDateMArrays" :key="items.id">
                                                    <p class="w-24 pl-3 text-sm font-semibold text-neutral-700">{{items.weekName}}</p>
                                                    <div v-for="item in items.days" :key="item.id" class="w-[85px] ml-4" >
                                                        <select class="shift-control-select" v-model="item.val">
                                                            <option :value="shift.shiftName" v-for="shift in shiftList" :key="shift.id">
                                                                {{ shift.shiftName }}
                                                            </option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>

                                            <div v-if="attendanceState2.everyWeekMen === 'no'" class="divide-y divide-[#eaeaea] w-fit">
                                                <div class="flex items-center py-4" v-for="items in specifyDateMOneArray" :key="items.id">
                                                    <p class="w-24 pl-3 text-sm font-semibold text-neutral-700">{{items.weekName}}</p>
                                                    <div v-for="item in items.days" :key="item.id" class="w-[85px] ml-4">
                                                        <select class="shift-control-select" v-model="item.val">
                                                            <!-- <option value="non-working">non-working</option> -->
                                                            <option :value="shift.shiftName" v-for="shift in shiftList" :key="shift.id">
                                                                {{ shift.shiftName }}
                                                            </option>                                                           
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                            <div>
                                                <div class="grid grid-cols-3 py-5 gap-7 border-t mt-5" >
                                                    <div>
                                                        <label class="input-label">Roster Name</label>
                                                        <input class="form-control"  v-model="attendanceState2.rosterName" type="text" placeholder="Enter Roster Name"/>
                                                        <p class="text-red-600" v-if="mRosterValidation && attendanceState2.rosterName == ''">This field is required</p>                               
                                                    </div>
                                                    <div>
                                                        <label class="input-label">Effective From</label>
                                                        <!-- <datepicker  v-model="attendanceState2.effectiveMFrom"  :disabled-date="disablePreviousDates"/>  -->
                                                        <!-- <month-picker-input v-model="attendanceState2.effectiveMFrom" :no-default="true"></month-picker-input> -->
                                                        <month-picker-input 
                                                            v-model="attendanceState2.effectiveMFrom" 
                                                            :no-default="true" 
                                                            @change="manualLogEffectiveFrom"
                                                        />
                                                        <p class="text-red-600" v-if="mRosterValidation && attendanceState2.effectiveMFrom == ''">This field is required</p>      
                                                    </div>
                                                    <div>
                                                        <label class="input-label">Effective To</label>
                                                        <!-- <datepicker v-model="attendanceState2.effectiveMTo"  :disabled-date="disablePreviousDates"/>    -->
                                                        <!-- <month-picker-input v-model="attendanceState2.effectiveMTo" :no-default="true"></month-picker-input> -->

                                                        <month-picker-input 
                                                            v-model="attendanceState2.effectiveMTo" 
                                                            :no-default="true" 
                                                            @change="manualLogEffectiveTo"
                                                        />
                                                        <p class="text-red-600" v-if="mRosterValidation && attendanceState2.effectiveMTo == ''">This field is required</p>      
                                                    </div>
                                                </div>
                                            </div>
                                            <div>
                                                <button 
                                                    type="button" 
                                                    class="ml-auto mr-2 btn-primary-light"
                                                    @click="addRosterDetails('save')"
                                                >
                                                    Save
                                                </button>
                                                <button 
                                                    type="button"
                                                    class="btn-primary"
                                                    @click="addRosterDetails('save and add new')"
                                                >
                                                    Save & Add New
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="pt-4 text-right">
                                    <button type="button" class="ml-auto mr-2 btn-gray-light" @click="this.addEducationDiv = false">
                                        <span class="pr-2">
                                            Cancel 
                                        </span>
                                    </button>
                                    <button type="submit" class=" btn-primary-light flex items-center" :disabled="buttonclick" :class="buttonclick == true ? 'opacity-50 cursor-not-allowed' : ''">
                                        <span class="pr-2">
                                            Submit 
                                        </span>
                                        <span>
                                            <span v-if="this.btnLoader" class="animate-spin h-4 w-4 inline-block border-2 border-white border-r-white/10 border-t-white/10 rounded-full"></span>
                                        </span>
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <RightSideBar/> -->
        </section>
    <!-- </AdminLayout> -->
</template>
<script>
    // import AdminLayout from '../AdminDashboard/AdminLayout.vue';
    // import RightSideBar from '../../components/RightSideBar.vue';
    import { reactive } from "vue";
    import { BASE_URL } from "../../config";
    import axios from "axios";
    // import Datepicker from 'vue3-datepicker';
    import { MonthPickerInput } from 'vue-month-picker'
    import { createLocal } from 'the-storages';
    import { createToast } from 'mosha-vue-toastify';

    const mirror = createLocal();
    const storage = mirror._prx;

    export default {
        name: 'AttendanceSetting',
        components:{
            // AdminLayout,
            // DropDown,
            // ArrowDownTrayIcon,
            // RightSideBar,
            // Datepicker,
            MonthPickerInput
        },
        setup() {
            const attendanceState = reactive({
                effectiveGFrom: "",
                effectiveGTo: "",
                defineFullShiftFrom: '',
                defineFullShiftTo: '',
                defineFullShiftHours: '',
                defineHalfShiftFrom: '',
                defineHalfShiftTo: '',
                defineHalfShiftHours: '',
                everyWeekGen:'',
                rosterName: ''
            })
            const attendanceState2 = reactive({
                effectiveMFrom: "",
                effectiveMTo: "",
                staryTimeData: '',
                endTimeData: '',
                defineHShiftFrom: '',
                defineHShiftTo: '',
                everyWeekMen:'',
                rosterName:'',
            })
    
            return {
                attendanceState,
                attendanceState2,
                // disabledDates: { to: new Date() }
            }
        },

        data() {
            return {
                btnLoader: false,
                buttonclick: false,
                storage:storage,
                shiftValidation:false,
                gRosterValidation:false,
                mRosterValidation:false,
                gShiftValidation:false,
                shiftType:'',
                specifyDateGArrays: [
                    {
                        weekName:'Week',
                        days: [
                            {name: 'Sunday', val: 'non-working'},
                            {name: 'Monday', val: 'full-day'},
                            {name: 'Tuesday', val: 'full-day'},
                            {name: 'Wednesday', val: 'full-day'},
                            {name: 'Thursday', val: 'full-day'},
                            {name: 'Friday', val: 'full-day'},
                            {name: 'Saturday', val: 'full-day'},
                        ]
                    },
                    {
                        weekName:'Week',
                        days: [
                            {name: 'Sunday', val: 'non-working'},
                            {name: 'Monday', val: 'full-day'},
                            {name: 'Tuesday', val: 'full-day'},
                            {name: 'Wednesday', val: 'full-day'},
                            {name: 'Thursday', val: 'full-day'},
                            {name: 'Friday', val: 'full-day'},
                            {name: 'Saturday', val: 'full-day'}
                        ]
                    },
                    {
                        weekName:'Week',
                        days: [
                            {name: 'Sunday', val: 'non-working'},
                            {name: 'Monday', val: 'full-day'},
                            {name: 'Tuesday', val: 'full-day'},
                            {name: 'Wednesday', val: 'full-day'},
                            {name: 'Thursday', val: 'full-day'},
                            {name: 'Friday', val: 'full-day'},
                            {name: 'Saturday', val: 'full-day'}
                        ]
                    },
                    {
                        weekName:'Week',
                        days: [
                            {name: 'Sunday', val: 'non-working'},
                            {name: 'Monday', val: 'full-day'},
                            {name: 'Tuesday', val: 'full-day'},
                            {name: 'Wednesday', val: 'full-day'},
                            {name: 'Thursday', val: 'full-day'},
                            {name: 'Friday', val: 'full-day'},
                            {name: 'Saturday', val: 'full-day'}
                        ]
                    },
                    {
                        weekName:'Week',
                        days: [
                            {name: 'Sunday', val: 'non-working'},
                            {name: 'Monday', val: 'full-day'},
                            {name: 'Tuesday', val: 'full-day'},
                            {name: 'Wednesday', val: 'full-day'},
                            {name: 'Thursday', val: 'full-day'},
                            {name: 'Friday', val: 'full-day'},
                            {name: 'Saturday', val: 'full-day'}
                        ]
                    },
                    
                ],
                specifyDateMArrays: [
                    {
                        weekName:'Week',
                        days: [
                            {name: 'Sunday', val: 'non-working'},
                            {name: 'Monday', val: 'non-working'},
                            {name: 'Tuesday', val: 'non-working'},
                            {name: 'Wednesday', val: 'non-working'},
                            {name: 'Thursday', val: 'non-working'},
                            {name: 'Friday', val: 'non-working'},
                            {name: 'Saturday', val: 'non-working'},
                        ]
                    },
                    {
                        weekName:'Week',
                        days: [
                            {name: 'Sunday', val: 'non-working'},
                            {name: 'Monday', val: 'non-working'},
                            {name: 'Tuesday', val: 'non-working'},
                            {name: 'Wednesday', val: 'non-working'},
                            {name: 'Thursday', val: 'non-working'},
                            {name: 'Friday', val: 'non-working'},
                            {name: 'Saturday', val: 'non-working'}
                        ]
                    },
                    {
                        weekName:'Week',
                        days: [
                            {name: 'Sunday', val: 'non-working'},
                            {name: 'Monday', val: 'non-working'},
                            {name: 'Tuesday', val: 'non-working'},
                            {name: 'Wednesday', val: 'non-working'},
                            {name: 'Thursday', val: 'non-working'},
                            {name: 'Friday', val: 'non-working'},
                            {name: 'Saturday', val: 'non-working'}
                        ]
                    },
                    {
                        weekName:'Week',
                        days: [
                            {name: 'Sunday', val: 'non-working'},
                            {name: 'Monday', val: 'non-working'},
                            {name: 'Tuesday', val: 'non-working'},
                            {name: 'Wednesday', val: 'non-working'},
                            {name: 'Thursday', val: 'non-working'},
                            {name: 'Friday', val: 'non-working'},
                            {name: 'Saturday', val: 'non-working'}
                        ]
                    },
                    {
                        weekName:'Week',
                        days: [
                            {name: 'Sunday', val: 'non-working'},
                            {name: 'Monday', val: 'non-working'},
                            {name: 'Tuesday', val: 'non-working'},
                            {name: 'Wednesday', val: 'non-working'},
                            {name: 'Thursday', val: 'non-working'},
                            {name: 'Friday', val: 'non-working'},
                            {name: 'Saturday', val: 'non-working'}
                        ]
                    },
                ],
                specifyDateGOneArray: [
                    {
                        weekName: 'Week',
                        days: [
                            {name: 'Sunday', val: 'non-working'},
                            {name: 'Monday', val: 'full-day'},
                            {name: 'Tuesday', val: 'full-day'},
                            {name: 'Wednesday', val: 'full-day'},
                            {name: 'Thursday', val: 'full-day'},
                            {name: 'Friday', val: 'full-day'},
                            {name: 'Saturday', val: 'full-day'},
                        ]
                    },
                ],
                specifyDateMOneArray: [
                    {
                        weekName: 'Week',
                        days: [
                            {name: 'Sunday', val: 'non-working'},
                            {name: 'Monday', val: 'non-working'},
                            {name: 'Tuesday', val: 'non-working'},
                            {name: 'Wednesday', val: 'non-working'},
                            {name: 'Thursday', val: 'non-working'},
                            {name: 'Friday', val: 'non-working'},
                            {name: 'Saturday', val: 'non-working'},
                        ]
                    },
                ],
                addNewShift:[
                    {shiftName:"", from:"", to:""}
                ],
                shiftList:[],
                rosterList:[],
                generalRosterList:[],
                isVisible: false,
                manualisVisible: false,

                showGrosterDeatils: {
                    workingDaysVaryWeekly: '',
                    specifyDateGArrays: [],
                    rosterName: '',
                    effectiveFrom:'',
                    effectiveTo:'',
                },

                showMrosterDeatils: {
                    workingDaysVaryWeekly: '',
                    specifyDateMArrays: [],
                    rosterName: '',
                    effectiveFrom:'',
                    effectiveTo:'',
                },
                //aSDetails:''
            }
        },

        async created(){
            this.getShiftList();
            this.getRosterList();
            this.getAttendanceSettingDetails();
            this.getGeneralRosterList();
        },

        methods:{
            async skipToDefault(){
                const formData2 = {
                    "step": 'attendance',
                    "companyId": this.storage.companyDetails.id,
                    "ipAddress": this.storage.ipAddress
                };
                await axios.post(BASE_URL + '/company-details-set-as-default',formData2)
                .then((response)=>{
                    console.log("SET AS DEFAULT DETAILS:: ",response.data);
                    if(response.data.country == 'success'){
                        this.closeModal();
                    }
                })
            },
            skipThisStep(){
                this.$emit('callbackProceed', 1)
            },
            clickToEdit(shift){
                //this.editDiv[index] = true;
                shift.editDiv = !shift.editDiv; // Toggle the editable stat
            },
            async editShift(id,name){
                const formData = {
                    "id": id,
                    "shiftName": name
                };
                console.log("data:",formData);
                await axios.put(BASE_URL + '/edit-shift',formData)
                .then((response)=>{
                    console.log(response.data);
                    //department.editDiv = false;
                    this.getShiftList();
                })
                
            },

            clickToEditRoster(roster){
                //this.editDiv[index] = true;
                roster.editDiv = !roster.editDiv; // Toggle the editable stat
            },
            async editRoster(id,name){
                const formData = {
                    "id": id,
                    "rosterName": name
                };
                console.log("data:",formData);
                await axios.put(BASE_URL + '/edit-roster',formData)
                .then((response)=>{
                    console.log(response.data);
                    //department.editDiv = false;
                    this.getRosterList();
                })
                
            },
            closeModal() {
                this.$emit('callback', false)
            },

            closeModalProceed(){
                // console.log(this.specifyDate)
                this.$emit('callbackProceed', 1)
            },
            addField() {
                this.addNewShift.push({shiftName:"", from:"", to:""}); 
            },
            removeField(index) {
                this.addNewShift.splice(index, 1); 
            },
            async getAttendanceSettingDetails(){
                const shiftData = {
                    "companyId": this.storage.companyDetails.id
                };
                await axios.post(BASE_URL + '/attendance-setting-details',shiftData)
                .then((response)=>{
                    this.shiftType =  response.data?.shiftType;
                    console.log("ATTENDANCE SETTING LIST:: ",response.data);
                    console.log("ATTENDANCE SETTING LIST2:: ",response.data?.rosterDetails[0]?.workingDaysVaryWeekly);

                    this.attendanceState.defineFullShiftFrom = response.data?.shiftDetails[0]?.shiftFrom;
                    this.attendanceState.defineFullShiftTo = response.data?.shiftDetails[0]?.shiftTo;
                    this.attendanceState.defineHalfShiftFrom = response.data?.shiftDetails[1]?.shiftFrom;
                    this.attendanceState.defineHalfShiftTo = response.data?.shiftDetails[1]?.shiftTo;
                    this.attendanceState.defineFullShiftHours = response.data.workingHoursData[0]?.total_working_hours;
                    this.attendanceState.defineHalfShiftHours = response.data.workingHoursData[1]?.total_working_hours;
                    // if(response.data?.rosterDetails[0]?.workingDaysVaryWeekly){
                    //     this.specifyDateGArrays = response.data.rosterDetails[0].allWeek
                    //     this.attendanceState.everyWeekGen = response.data?.rosterDetails[0]?.workingDaysVaryWeekly;
                    //     this.attendanceState.effectiveGFrom = (new Date(response.data?.rosterDetails[0]?.effectiveFrom))?new Date(response.data?.rosterDetails[0]?.effectiveFrom) :new Date();
                    //     this.attendanceState.effectiveGTo = (new Date(response.data?.rosterDetails[0]?.effectiveTo))?new Date(response.data?.rosterDetails[0]?.effectiveTo):new Date();
                    // }
                    console.log("this.attendanceState.everyWeekGen",this.attendanceState.everyWeekGen);
                    //this.shiftType = this.shiftType;
                })
            },
            async getShiftList(){
                const shiftData = {
                    "companyId": this.storage.companyDetails.id
                };
                await axios.post(BASE_URL + '/shift-list',shiftData)
                .then((response)=>{
                    // this.shiftList =  response.data.shiftList;
                    this.shiftList = response.data.shiftList;

                    // Check if "non-working" shift exists, if not, add it
                    const nonWorkingShift = this.shiftList.find(shift => shift.shiftName === "non-working");
                    if (!nonWorkingShift) {
                        this.shiftList.unshift({
                            _id: "non-working", // Static ID for the default shift
                            shiftName: "non-working",
                            shiftFrom: "00:00",
                            shiftTo: "00:00"
                        });
                    }
                    console.log("SHIFT LIST:: ",response.data);
                })
            },
            async getRosterList(){
                const rosterData = {
                    "companyId": this.storage.companyDetails.id
                };
                await axios.post(BASE_URL + '/roster-list',rosterData)
                .then((response)=>{
                    this.rosterList =  response.data.rosterList;
                    console.log("ROSTER LIST:: ",response.data);
                })
            },
            async addShiftDetails(){
                const hasEmptyValue = this.addNewShift.some(shift => 
                    !shift.shiftName || !shift.from || !shift.to
                );

                if (hasEmptyValue) {
                    this.shiftValidation = true;        
                    return false;
                }                                    
                const formData = {
                    "companyId": this.storage.companyDetails.id,
                    "ipAddress": this.storage.ipAddress,
                    "shiftType": this.shiftType,
                    "shiftDetails": this.addNewShift
                };
                //alert("SUBMIT IN",formData);
                await axios.post(BASE_URL + '/add-shift-details',formData)
                .then((response)=>{
                    console.log(response.data);
                    this.addNewShift    = [{shiftName:"", from:"", to:""}];
                    this.getShiftList();
                    this.shiftValidation = false;
                })
            },
            async addRosterDetails(value){
                if(this.attendanceState2.everyWeekMen){
                    this.mRosterValidation = true; 
                    if(this.attendanceState2.rosterName == '' || this.attendanceState2.effectiveMFrom == '' || this.attendanceState2.effectiveMTo == ''){                           
                        return false;
                    }
                }
                const formData = {
                    "companyId": this.storage.companyDetails.id,
                    "ipAddress": this.storage.ipAddress,
                    "shiftType": this.shiftType == 'Manual' ? 'manual' : 'general',
                    "effectiveFrom": this.attendanceState2.effectiveMFrom,
                    "effectiveTo": this.attendanceState2.effectiveMTo,
                    // "shiftDetails": this.addNewShift,
                    "rosterName": this.attendanceState2.rosterName,
                    "everyWeekMen": this.attendanceState2.everyWeekMen,
                    "specifyDateMArrays": (this.attendanceState2.everyWeekMen=='yes')? this.specifyDateMArrays:'',
                    "specifyDateMOneArray": (this.attendanceState2.everyWeekMen=='no')? this.specifyDateMOneArray:'',
                };
                //alert("SUBMIT IN",formData);
                await axios.post(BASE_URL + '/add-roster-details',formData)
                .then((response)=>{
                    console.log(response.data);
                    if(value!='save'){
                        this.attendanceState2.rosterName = '';
                        this.attendanceState2.effectiveMFrom = new Date();
                        this.attendanceState2.effectiveMTo = new Date();
                        this.arrayBlank();
                        //this.specifyDateMArrays = [];
                        //this.specifyDateMOneArray = [];
                    }
                    this.getRosterList();
                    if(response.data.success === 'success'){
                        this.tostMessage('success', response.data.message);
                    }else{
                        this.tostMessage('danger', response.data.message);
                    }
                })
            },
            async submitAttendanceForm(){
                let formData = [];
                
                if(this.shiftType==='General'){  
                    // if(this.attendanceState.everyWeekGen){
                        
                        if(this.attendanceState.rosterName == '' || this.attendanceState.effectiveGFrom == '' || this.attendanceState.effectiveGTo == '' || this.attendanceState.defineFullShiftFrom == '' || this.attendanceState.defineFullShiftTo == '' || this.attendanceState.defineHalfShiftFrom == '' || this.attendanceState.defineHalfShiftTo == '' || this.attendanceState.everyWeekGen == ''){      
                            this.gRosterValidation = true;       
                            // console.log("1st", this.attendanceState)              
                            return false;
                        }
                    // }
                        // console.log("okay")
                    // if(this.attendanceState.defineFullShiftFrom == '' || this.attendanceState.defineFullShiftTo == '' || this.attendanceState.defineHalfShiftFrom == '' || this.attendanceState.defineHalfShiftTo == ''){
                    //     this.gShiftValidation = true;        
                    //     return false;
                    // }
                    
                    formData = {
                        "companyId": this.storage.companyDetails.id,
                        "rosterName": this.attendanceState.rosterName,
                        "ipAddress": this.storage.ipAddress,
                        "shiftType": this.shiftType,
                        "effectiveFrom": this.attendanceState.effectiveGFrom,
                        "effectiveTo": this.attendanceState.effectiveGTo,
                        "staryTimeData": this.attendanceState.staryTimeData,
                        "endTimeData": this.attendanceState.endTimeData,
                        "defineFullShiftFrom": this.attendanceState.defineFullShiftFrom,
                        "defineFullShiftTo": this.attendanceState.defineFullShiftTo,
                        "defineFullShiftHours": this.attendanceState.defineFullShiftHours,
                        "defineHalfShiftFrom": this.attendanceState.defineHalfShiftFrom,
                        "defineHalfShiftTo": this.attendanceState.defineHalfShiftTo,
                        "defineHalfShiftHours": this.attendanceState.defineHalfShiftHours,
                        "everyWeekGen": this.attendanceState.everyWeekGen,
                        "specifyDateGArrays": (this.attendanceState.everyWeekGen=='yes')? this.specifyDateGArrays:'',
                        "specifyDateGOneArray": (this.attendanceState.everyWeekGen=='no')? this.specifyDateGOneArray:'',
                    };
                    // console.log("submit form data",formData);
                    //alert("SUBMIT IN",formData);
                   
                } else {
                    if(this.attendanceState2.everyWeekMen){
                        this.mRosterValidation = true; 
                        if(this.attendanceState2.rosterName == '' || this.attendanceState2.effectiveMFrom == '' || this.attendanceState2.effectiveMTo == ''){                           
                            return false;
                        }
                    }
                    formData = {
                        "companyId": this.storage.companyDetails.id,
                        "ipAddress": this.storage.ipAddress,
                        "shiftType": this.shiftType,
                        "effectiveFrom": this.attendanceState2.effectiveMFrom,
                        "effectiveTo": this.attendanceState2.effectiveMTo,
                        "defineFullShiftHours": this.attendanceState.defineFullShiftHours,
                        "defineHalfShiftHours": this.attendanceState.defineHalfShiftHours,
                        "shiftDetails": this.addNewShift,
                        "rosterName": this.attendanceState2.rosterName,
                        "everyWeekMen": this.attendanceState2.everyWeekMen,
                        "specifyDateMArrays": (this.attendanceState2.everyWeekMen=='yes')? this.specifyDateMArrays:'',
                        "specifyDateMOneArray": (this.attendanceState2.everyWeekMen=='no')? this.specifyDateMOneArray:'',
                    };
                   
                }
                this.buttonclick = true;
                this.btnLoader = true;
                await axios.post(BASE_URL + '/submit-attendance-setting',formData)
                .then((response)=>{
                    console.log(response.data);
                    if(response.data.success === 'success'){                       
                        this.tostMessage('success', response.data.message);  
                        if(this.shiftType == 'General'){
                            this.buttonclick = false;
                            this.btnLoader = false;
                            this.getGeneralRosterList();

                        }else{
                            this.buttonclick = false;
                            this.btnLoader = false;
                            this.getRosterList(); 
                        }                     
                    }else{
                        this.buttonclick   = false;
                        this.btnLoader     = false;
                        this.tostMessage('danger', response.data.message);
                    }
                   
                })
               
              
                
            },
            logEffectiveFrom(value) {
                console.log("Effective From Changed:", value);
                this.attendanceState.effectiveGFrom = `${value.year}-${String(value.monthIndex).padStart(2, '0')}`;
            },
            logEffectiveTo(value) {
                console.log("Effective To Changed:", value);
                this.attendanceState.effectiveGTo = `${value.year}-${String(value.monthIndex).padStart(2, '0')}`;
            },
            manualLogEffectiveFrom(value) {
                console.log("Effective From Changed:", value);
                this.attendanceState2.effectiveMFrom = `${value.year}-${String(value.monthIndex).padStart(2, '0')}`;
            },
            manualLogEffectiveTo(value) {
                console.log("Effective To Changed:", value);
                this.attendanceState2.effectiveMTo = `${value.year}-${String(value.monthIndex).padStart(2, '0')}`;
            },
            arrayBlank(){
                this.specifyDateMArrays = [
                    {
                        weekName:'Week',
                        days: [
                            {name: 'Sunday', val: 'non-working'},
                            {name: 'Monday', val: 'non-working'},
                            {name: 'Tuesday', val: 'non-working'},
                            {name: 'Wednesday', val: 'non-working'},
                            {name: 'Thursday', val: 'non-working'},
                            {name: 'Friday', val: 'non-working'},
                            {name: 'Saturday', val: 'non-working'},
                        ]
                    },
                    {
                        weekName:'Week',
                        days: [
                            {name: 'Sunday', val: 'non-working'},
                            {name: 'Monday', val: 'non-working'},
                            {name: 'Tuesday', val: 'non-working'},
                            {name: 'Wednesday', val: 'non-working'},
                            {name: 'Thursday', val: 'non-working'},
                            {name: 'Friday', val: 'non-working'},
                            {name: 'Saturday', val: 'non-working'}
                        ]
                    },
                    {
                        weekName:'Week',
                        days: [
                            {name: 'Sunday', val: 'non-working'},
                            {name: 'Monday', val: 'non-working'},
                            {name: 'Tuesday', val: 'non-working'},
                            {name: 'Wednesday', val: 'non-working'},
                            {name: 'Thursday', val: 'non-working'},
                            {name: 'Friday', val: 'non-working'},
                            {name: 'Saturday', val: 'non-working'}
                        ]
                    },
                    {
                        weekName:'Week',
                        days: [
                            {name: 'Sunday', val: 'non-working'},
                            {name: 'Monday', val: 'non-working'},
                            {name: 'Tuesday', val: 'non-working'},
                            {name: 'Wednesday', val: 'non-working'},
                            {name: 'Thursday', val: 'non-working'},
                            {name: 'Friday', val: 'non-working'},
                            {name: 'Saturday', val: 'non-working'}
                        ]
                    },
                    {
                        weekName:'Week',
                        days: [
                            {name: 'Sunday', val: 'non-working'},
                            {name: 'Monday', val: 'non-working'},
                            {name: 'Tuesday', val: 'non-working'},
                            {name: 'Wednesday', val: 'non-working'},
                            {name: 'Thursday', val: 'non-working'},
                            {name: 'Friday', val: 'non-working'},
                            {name: 'Saturday', val: 'non-working'}
                        ]
                    },
                ];
                this.specifyDateMOneArray = [
                    {
                        weekName: 'Week',
                        days: [
                            {name: 'Sunday', val: 'non-working'},
                            {name: 'Monday', val: 'non-working'},
                            {name: 'Tuesday', val: 'non-working'},
                            {name: 'Wednesday', val: 'non-working'},
                            {name: 'Thursday', val: 'non-working'},
                            {name: 'Friday', val: 'non-working'},
                            {name: 'Saturday', val: 'non-working'},
                        ]
                    },
                ];
            },
            disablePreviousDates(date) {
                return date < new Date().setHours(0, 0, 0, 0); // Disable past dates
            },
            async deleteShift(shiftName) {
                if (shiftName === "non-working") {
                    alert("The 'Non-Working' shift cannot be deleted.");
                    return;
                }
                const companyId = this.storage.companyDetails.id;
                await axios.delete(`${BASE_URL}/delete-shift/${companyId}/${shiftName}`).then((response) => {
                    console.log(response.data);
                    this.getShiftList();
                }).catch(error => {
                    console.error("Error deleting shift:", error);
                });
            },
                    
            tostMessage(status,message){
                createToast({
                    // title: title,
                    description: message
                },
                {
                type: status,
                timeout: 2500,
                position: 'bottom-right',
                showIcon: 'true'
                })
            },
            async getGeneralRosterList() {               
                const companyId = this.storage.companyDetails.id;
                await axios.post(`${BASE_URL}/get-general-roster-list`, {companyId:companyId}).then((response) => {
                  this.generalRosterList = response.data.rosterList;
                }).catch(error => {
                    console.error("Error deleting shift:", error);
                });
            },

            toggleVisibility(id) {
                this.isVisible = !this.isVisible; // Toggle visibility on every click

                // Find the roster with the matching ID
                const selectedRoster = this.generalRosterList.find(roster => roster.id === id);

                if (selectedRoster) {
                    // Set the values from the selected roster
                    this.showGrosterDeatils.workingDaysVaryWeekly = selectedRoster.workingDaysVaryWeekly || ''; // Default to an empty string if not found
                    this.showGrosterDeatils.specifyDateGArrays = selectedRoster.allWeek || []; // Default to an empty array if not found
                    this.showGrosterDeatils.rosterName = selectedRoster.rosterName || ''; // Default to an empty string if not found
                    this.showGrosterDeatils.effectiveFrom= selectedRoster.effectiveFrom || ''; // Default to an empty string if not found
                    this.showGrosterDeatils.effectiveTo=  selectedRoster.effectiveTo || '';
                } else {
                    console.error("Roster not found for ID:", id);
                }
            },

            toggleVisibilityManual(id) {
                this.manualisVisible = !this.manualisVisible; // Toggle visibility on every click

                // Find the roster with the matching ID
                const selectedRoster = this.rosterList.find(roster => roster.id === id);

                if (selectedRoster) {
                    // Set the values from the selected roster
                    this.showMrosterDeatils.workingDaysVaryWeekly = selectedRoster.workingDaysVaryWeekly || ''; // Default to an empty string if not found
                    this.showMrosterDeatils.specifyDateMArrays = selectedRoster.allWeek || []; // Default to an empty array if not found
                    this.showMrosterDeatils.rosterName = selectedRoster.rosterName || ''; // Default to an empty string if not found
                    this.showMrosterDeatils.effectiveFrom= selectedRoster.effectiveFrom || ''; // Default to an empty string if not found
                    this.showMrosterDeatils.effectiveTo=  selectedRoster.effectiveTo || '';
                } else {
                    console.error("Roster not found for ID:", id);
                }
            },
        },
        watch:{
        },
    }


</script>
<style>
    .shift-control-select{
        @apply w-full text-xs border rounded px-1.5 text-neutral-500 py-1 outline-0 focus:border-blue-500;
    }
    .radio-box input{
        @apply hidden;
    }
    .radio-box .radio-label{
        @apply rounded border py-4 px-5 w-48 flex items-center text-neutral-600 before:w-5 before:h-5 before:rounded-full before:border before:mr-4
                before:border-neutral-300 transition-all before:transition-all before:content-['\00B7'] before:text-transparent before:text-8xl before:leading-3 before:flex before:items-center;
    }

    .radio-box input[type=radio]:checked + .radio-label{
        @apply bg-blue-50 border-blue-200 text-blue-600 before:border-blue-50 before:border-4 before:bg-blue-600 before:border-spacing-4 before:outline before:outline-1 before:outline-blue-600;
    }

    .time-preview {
  border: 1px solid #eee;
  max-width: 400px;
  text-align: center;
  margin: 0 auto;
  margin-bottom: 20px;
  padding: 15px;
  background: rgb(70, 25, 173);
  color: #fff;
}

.time-preview-time {
  font-size: 30px;
}

</style>
<style>
    .error {
        display: block;
        padding-bottom: 0.5rem;
        font-size: 0.575rem;
        line-height: 1.25rem;
        --tw-text-opacity: 1;
        color: rgb(239 68 68 / var(--tw-text-opacity));
    }
    .date-field {
        line-height: 1.75rem !important;
    }
</style>